Greenmile.Components = Greenmile.Components || {};
Greenmile.Components.AddAttribute = Greenmile.Components.AddAttribute || {};

Greenmile.Components.AddAttribute.AutoComplete = function (fieldEl) {

    this.autoCompleteTags = [];

    this.loadAvailableTags = (entitiesPropertiesList) => {
        const entitiesPropertiesListToUse = entitiesPropertiesList || defaultEntitiesPropertiesList;
        this.autoCompleteTags = [];

        this.autoCompleteTags.push({
            label: '',
            value: ''
        });

        for (let i = 0; i < entitiesPropertiesListToUse.length; i++) {

            const translatedResource = Monet.I18n.getResourcesByKey('SelectKeyResource.' + entitiesPropertiesListToUse[i]);

            this.autoCompleteTags.push({
                label: translatedResource,
                value: entitiesPropertiesListToUse[i]
            });
        }

        markFields(fieldEl);

        return this.autoCompleteTags;

    };

    const split = (val) => {
        return val.split(/@\S*/);
    };

    const extractLast = (term) => {
        return split(term).pop();
    };
    
    const markFields = (fieldEl) => {
        const autoCompleteTags = this.autoCompleteTags;
        const textareas = fieldEl.querySelectorAll('[class*="autocomplete_"]');
        for (let x = 0, size = textareas.length; x < size; x++) {
            const field = textareas[x];
            $(field)
                .on("keypress",
                function () {
                    $(field)
                        // don't navigate away from the field on
                        // tab when selecting an item
                        .on(
                        "keydown",
                        function (event) {
                            if (event.keyCode === $.ui.keyCode.TAB && $(this)
                                    .data("autocomplete").menu.active) {
                                event.preventDefault();
                            }
                        })
                        .autocomplete({
                            minLength: 0,
                            source: function (request, response) {
                                // delegate back to
                                // autocomplete, but
                                // extract the last term
                                const regex = /@([^\s]+)/;
                                let term = request.term;

                                while (term.match(regex) !== null) {

                                    const value = term.match(regex);

                                    if (value[1].indexOf('@') === -1) {
                                        const element = $.ui.autocomplete.filter(
                                            autoCompleteTags,
                                            extractLast(
                                                value[1].replace('@', '')));
                                        response(element);
                                    }

                                    term = term.replace(value[0], '');
                                }
                            },
                            focus: function () {
                                // prevent value
                                // inserted on focus
                                return false;
                            },
                            select: function (event, ui) {

                                var terms         = this.value.split(/(@[^\s,.;:@]+)(\s|$)/),
                                    originalTerm,
                                    indexOfOriginalTermInTags,
                                    endOfSentence = terms[3],
                                    tagSplit      = ui.item.label.split(' ');

                                originalTerm = terms[1];
                                originalTerm = originalTerm.substring(1);
                                const value = ui.item.value;
                                terms[1] = (value.indexOf("@") === -1 ? `@${value}@` : value);

                                for (var i = 0; i < tagSplit.length; i++) {

                                    if (originalTerm.toUpperCase() === tagSplit[i].toUpperCase()) {

                                        indexOfOriginalTermInTags = i;

                                    }

                                }

                                for (var j = indexOfOriginalTermInTags + 1; j < tagSplit.length; j++) {

                                    var tag        = tagSplit[j],
                                        indexOfTag = endOfSentence.indexOf(tag);

                                    if (indexOfTag !== -1) {

                                        endOfSentence = endOfSentence.substring(indexOfTag + tag.length);

                                    } else {

                                      break;

                                    }

                                }

                                terms[3] = endOfSentence;
                                this.value = terms.join("");

                                return false;
                            }
                        });
                });
        }
    };

    const defaultEntitiesPropertiesList = [
        "Equipment.key",
        "Equipment.description",
        "Equipment.equipmentType.key",
        "Equipment.equipmentType.description",
        "Equipment.equipmentType.weight",
        "Equipment.equipmentType.height",
        "Equipment.equipmentType.size1",
        "Equipment.equipmentType.size2",
        "Equipment.equipmentType.size3",
        "Stop.location.key",
        "Stop.location.accountType.key",
        "Stop.location.accountType.description",
        "Stop.location.locationType.key",
        "Stop.location.locationType.description",
        "Stop.location.timeWindowType.key",
        "Stop.location.timeWindowType.description",
        "Stop.location.serviceTimeType.key",
        "Stop.location.serviceTimeType.description",
        "Stop.location.description",
        "Stop.location.addressLine1",
        "Stop.location.addressLine2",
        "Stop.location.city",
        "Stop.location.state",
        "Stop.location.zipCode",
        "Stop.location.district",
        "Stop.location.longitude",
        "Stop.location.latitude",
        "Stop.location.phone1",
        "Stop.location.phone1Type",
        "Stop.location.phone2",
        "Stop.location.phone2Type",
        "Stop.location.email",
        "Stop.location.deliveryInstructions",
        "Stop.key",
        "Stop.baseLineSequenceNum",
        "Stop.plannedSequenceNum",
        "Stop.actualSequenceNum",
        "Stop.stopType.description",
        "Stop.baseLineArrival",
        "Stop.plannedArrival",
        "Stop.projectedArrival",
        "Stop.actualArrival",
        "Stop.baseLineService",
        "Stop.plannedService",
        "Stop.projectedService",
        "Stop.actualService",
        "Stop.baseLineDeparture",
        "Stop.plannedDeparture",
        "Stop.projectedDeparture",
        "Stop.actualDeparture",
        "Stop.baseLineDistance",
        "Stop.plannedDistance",
        "Stop.projectedDistance",
        "Stop.actualDistance",
        "Stop.baseLineSize1",
        "Stop.baseLineSize2",
        "Stop.baseLineSize3",
        "Stop.plannedSize1",
        "Stop.plannedSize2",
        "Stop.plannedSize3",
        "Stop.actualSize1",
        "Stop.actualSize2",
        "Stop.actualSize3",
        "Stop.plannedPickupSize1",
        "Stop.plannedPickupSize2",
        "Stop.plannedPickupSize3",
        "Stop.baseLinePickupSize1",
        "Stop.baseLinePickupSize2",
        "Stop.baseLinePickupSize3",
        "Stop.actualPickupSize1",
        "Stop.actualPickupSize2",
        "Stop.actualPickupSize3",
        "Stop.damagedSize1",
        "Stop.damagedSize2",
        "Stop.damagedSize3",
        "Stop.instructions",
        "Stop.deliveryReasonCode.description",
        "Stop.overReasonCode.description",
        "Stop.shortReasonCode.description",
        "Stop.damagedReasonCode.description",
        "Stop.pickupReasonCode.description",
        "Stop.cancelCode.description",
        "Stop.undeliverableCode.description",
        "Stop.arrivalLatitude",
        "Stop.arrivalLongitude",
        "Stop.arrivalAccuracyMeters",
        "Stop.arrivedInTimeWindow",
        "Stop.serviceLatitude",
        "Stop.serviceAccuracyMeters",
        "Stop.serviceLongitude",
        "Stop.longitude",
        "Stop.latitude",
        "Stop.ordersInfo",
        "Route.date",
        "Route.key",
        "Route.description",
        "Route.origin.key",
        "Route.origin.description",
        "Route.origLatitude",
        "Route.origLongitude",
        "Route.destination.key",
        "Route.destination.description",
        "Route.destLatitude",
        "Route.destLongitude",
        "Route.baseLineArrival",
        "Route.baseLineDeparture",
        "Route.plannedArrival",
        "Route.plannedDeparture",
        "Route.projectedArrival",
        "Route.projectedDeparture",
        "Route.actualArrival",
        "Route.actualDeparture",
        "Route.baseLineDistance",
        "Route.plannedDistance",
        "Route.projectedDistance",
        "Route.actualDistance",
        "Route.baseLineComplete",
        "Route.plannedComplete",
        "Route.projectedComplete",
        "Route.actualComplete",
        "Route.baseLineCost",
        "Route.plannedCost",
        "Route.actualCost",
        "Route.baseLineStart",
        "Route.plannedStart",
        "Route.projectedStart",
        "Route.actualStart",
        "Route.hasHelper",
        "Route.driversName",
        "Route.totalStops",
        "Route.canceledStops",
        "Route.undeliveredStops",
        "Route.redeliveredStops",
        "Route.actualTravelTimeMinutes",
        "Route.plannedTravelTimeMinutes",
        "Route.baselineTravelTimeMinutes",
        "Route.hasPicture",
        "Order.number",
        "Order.plannedSize1",
        "Order.plannedSize2",
        "Order.plannedSize3",
        "Order.actualSize1",
        "Order.actualSize2",
        "order.actualSize3",
        "Order.plannedPickupSize1",
        "Order.plannedPickupSize2",
        "Order.plannedPickupSize3",
        "Order.actualPickupSize1",
        "Order.actualPickupSize2",
        "Order.actualPickupSize3",
        "Order.damagedSize1",
        "Order.damagedSize2",
        "order.damagedSize3",
        "Order.specialInstructions",
        "Order.deliveryReasonCode.description",
        "Order.overReasonCode.description",
        "Order.shortReasonCode.description",
        "Order.damagedReasonCode.description",
        "Order.pickupReasonCode.description",
        "Order.salesMan.key",
        "Order.salesMan.name",
        "Driver.key",
        "Driver.name",
        "Driver.login",
        "HoursOfService.onDuty"
    ];
};
